import api from 'api';
import useAsyncEffect from 'lib/frontend/hooks/useAsyncEffect';
import { isColumnUser } from 'lib/helpers';
import { ColumnService } from 'lib/services/directory';
import { useAppSelector } from 'redux/hooks';
import { selectUser } from 'redux/auth';

const FALLBACK_COLORS = [
  'column-primary',
  'column-green',
  'column-red',
  'indigo',
  'column-yellow',
  'teal',
  'pink',
  'column-blue',
  'orange'
];

export type Paginator = {
  id: string;
  name: string;
  color: string;
};

type PaginatorListResponse = Paginator[];

export function useAvailablePaginators(): Paginator[] {
  const user = useAppSelector(selectUser);

  const { value } = useAsyncEffect<PaginatorListResponse>({
    fetchData: async () => {
      if (!user || !isColumnUser(user)) return [];
      const result = await api.safeGet('pagination/paginators');
      if (result.error)
        throw new Error(result.error ?? 'Failed to fetch paginators');
      return (result.response?.paginators ?? []).map((p, i) => ({
        id: p.id,
        name: p.name,
        color: p.userColor ?? FALLBACK_COLORS[i % FALLBACK_COLORS.length]
      }));
    },
    dependencies: [user?.id],
    errorConfig: {
      service: ColumnService.PAGINATION,
      message: 'Failed to fetch available paginators'
    }
  });

  return value ?? [];
}
